import type { AchordData } from 'src/app';
import { getProfile } from './profiles';

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;


function random(min: number, max: number) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}


export class Text_Transformer {
	private rollingTimestamp;
	public entries: AchordData.Entry[]

	constructor(text: string, offsetInHours = 4) {
		this.rollingTimestamp = new Date().getTime() - offsetInHours * HOUR;
		this.entries = this.parseText(text);
	}

	dynamicTime() {
		const result = this.rollingTimestamp;
		this.rollingTimestamp -= random(1 * MINUTE, 5 * MINUTE);
		return new Date(result).toLocaleTimeString();
	}

	setRandomTime() {
		this.rollingTimestamp = new Date().getTime() - random(1 * HOUR, 24 * HOUR);
	}


	private parseText(text: string): AchordData.Entry[] {
		const lines = text.trim().split('\n').filter((line) => line.length > 0);
		return lines
			.reverse()
			.map(this.parseMessage)
			.reverse();
	}

	parseMessage = (message: string): AchordData.Entry => {
		
		if (message.substring(0, 2) === '--') {
			this.setRandomTime();
			return {
				type: 'separator',
				text: message.substring(2),
				protected: true,
			};
		}

		const author = message.split(':')[0] as string;
		const text = message.split(':')[1] as string;

		if (!author || !text) {
			console.error('Invalid message', message);
		}

		return {
			type: 'message',
			author: getProfile(author.trim()),
			content: text.trim(),
			time: this.dynamicTime()
		};

	}

	getParticipantNames() {
		return this.entries
			.filter((entry): entry is AchordData.Message => 'author' in entry)
			.map((entry: AchordData.Message) => entry.author.name);
	}
}